/**
 * Module dependencies.
 */

import { Box, BoxProps, Button, Stack } from '@mui/material';
import styled from '@emotion/styled';

/**
 * Export `FormContainer` styled component.
 */

export const FormContainer = styled(Box)<BoxProps>`
  max-width: 100%;
  flex: 1;
`;

/**
 * Export `InputGroup` styled component.
 */

export const InputGroup = styled(Stack)`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 600px) {
    flex-direction: row;
  }
`;

/**
 * Export `FormStack` styled component.
 */

export const FormStack = styled(Stack)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

/**
 * Export `SubmitButton` styled component.
 */

export const SubmitButton = styled(Button)``;
